import { render, staticRenderFns } from "./ShowMediaLink.vue?vue&type=template&id=13030c92"
import script from "./ShowMediaLink.vue?vue&type=script&lang=js"
export * from "./ShowMediaLink.vue?vue&type=script&lang=js"
import style0 from "./ShowMediaLink.vue?vue&type=style&index=0&id=13030c92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports